import { FetchProfilesFilter } from "@/types/api-payload";
import { MIDDLEWARE } from "../constants/api";
import { ManageFolderTabs } from "../types";
import { getFolderIdFromURL } from "./getFolderId";
import { IContactInfoValues, IInitialFilterState } from "@/pages/FolderManagement/context/FilterContext";
import { IFilterFormValues } from "@/redux/reducers/filterFormValuesSlice/initialState";
import { getUserDetails } from "./getUserDetails";

export const extractDomain = () => {
  let domain = "";
  const url = window.location.origin;
  if (url.includes("localhost") || url.includes("test")) {
    domain = "https://recruiter.foundit.in";
  } else {
    domain = window.location.origin;
  }
  return domain;
};

export const StateMap:{[key:number]:string} = {0:"prospect",9:"jobApplicant",12:"interviewed"} 

export function extractBaseServer(url:string) {
  if (url.includes("localhost") || url.includes("test") ) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split('.');
  const domain = parts[parts.length - 2] + '.' + parts[parts.length - 1];

  return domain;
}

export function callFromMiddleware(url: string): string {
  return `${MIDDLEWARE}${url}`;
}

export function activeTabFolderCount(
  folderData: ManageFolderTabs[],
  activeTab: string
) {
  const tab = folderData.find(
    (tab: ManageFolderTabs) => tab.label === activeTab
  );

  if (tab) {
    return tab.folderCount;
  } else {
    return 0;
  }
}

export function formatDate(inputDate: string) {
  if (inputDate === null) return "NA"
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const parsedDate = new Date(inputDate);
  const formattedDate = parsedDate.toLocaleString("en-US", options);

  return formattedDate;
}

export function formatCommentsDate(inputDate: string) {
  if (inputDate === null) return "NA";

  const date = new Date(inputDate);
  const day = date.getDate();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 || 12;

  const formattedDate = `${day} ${month} ${year}, ${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

  return formattedDate;
}

export function formatDateWithoutTime(inputDate: string) {
  if (inputDate === null) return "NA"
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const parsedDate = new Date(inputDate);
  const formattedDate = parsedDate.toLocaleString("en-US", options);

  return formattedDate;
}

export function transformString(inputString: string) {
  if (!inputString) return "";

  const words: string[] = inputString.split('_');

  const transformedString: string = words
    .map(word => word.toLowerCase())
    .join(' ');

  return transformedString.charAt(0).toUpperCase() + transformedString.slice(1);
}

export function getFolderRedirectionPath(id: number, sharedBy: number | null = null, isAutoMatch: boolean,isLinkedJobTitleVisible=false, isRevamp = false) {
  const domain = extractDomain();


  let baseUrl =  `/edge/foldermanagement`;

  if(isRevamp){
    // redirect to new FM Page
   baseUrl = `/edge/recruiter-fm/folder-details`
  }

  let url = `${domain}${baseUrl}?folderID=${id}&autoMatch=${isAutoMatch}&jobLinked=${isLinkedJobTitleVisible}`;
  if (sharedBy) {
    url = url + `&sharedBy=${sharedBy}`;
  }
  return url;
}

export function getManageFolderRedirectionPath() {
  const domain = extractDomain();
  return `${domain}/edge/foldermanagement/manage-folder`;
}

export function getOutreachRedirectionPath(campaignInitiationDetails: any, timeZone: any) {
  const domain = extractDomain();
  return `${domain}/edge/recruiter-outreach-email/campaing/creation?initiationId=${campaignInitiationDetails?.id}&timeZone=${timeZone}&isBulkCampaign=${campaignInitiationDetails?.isBulkCampaign}`
}
export function getOutreachWhatsappRedirectionPath(campaignInitiationDetails: any, timeZone: any) {
  const domain = extractDomain();
  return `${domain}/edge/recruiter-outreach-email/campaign/creation/whatsApp?initiationId=${campaignInitiationDetails?.id}&timeZone=${timeZone}&triggeredFromPage=FOLDER&isBulkCampaign=${campaignInitiationDetails?.isBulkCampaign}`
}

export function getCDPRedirectionPath(profile_uuid: string, psc: string = '',fId:number|string) {
  const domain = extractDomain();
  const secondParam = psc ? `&psc=${psc}` : ''
  const thirdParam= fId ? `&folderId=${fId}` : ''
  return `${domain}/edge/recruiter-cdp/profile?p_uuid=${profile_uuid}${secondParam}${thirdParam}`;
}


export function transformInsights(inputArray: string[], insightsMap: { key: string, text: string }[]): { key: string, text: string }[] {
  const transformedInsights = inputArray.map(item => {
    const insights = insightsMap.find((insight: { key: string, text: string }) => insight.key === item);
    return insights ? insights : { key: item, text: 'No Match Found' };
  });

  return transformedInsights.filter(insight => insight.text !== 'No Match Found');
}

export function convertFilterStateFilterPayload(
  state: IInitialFilterState
): FetchProfilesFilter {
  const folderId = getFolderIdFromURL();

  const company = (state.designations?.length || state.designations_categories?.length || state.currentCompany?.length || state.experience || state.salary) 
  ? 
  {
    current_designation:state.designations,
    designations_categories:state.designations_categories,
    //current_designation: state.currentDesignation,
    current_company: state.currentCompany,
    experience: state.experience,
    salary: state.salary,
    is_preferred_designations:state.is_preferred_designations,
    designations_scope: state.designations_scope,
  }
   : {  is_preferred_designations:state.is_preferred_designations};

  //const transformedContactedBy: number[] = state?.contactedBy?.map(type => type.value)! 
// console.log("stateam",state.sort_by_profile_ranking_score)
  const payload: FetchProfilesFilter = {
    from: state.from || 0,
    size: state.size || 40,
    // sort_by_profile_ranking_score: state.sort_by_profile_ranking_score || false,
    sort_by: {"field": state.sort_by_profile_ranking_score ?"p_profile_ranking_score":"application_date", "order": "desc"},
    filters: {
      folder_search: {
        folder_id: folderId,
        response_type: state.responseType,
        contacted_within: state.contactedWithin,
        contacted_by: state.contactedBy,
        shortlisted_within: state.shortlistedWithin,
        skills:{
                "must_have":state["Must Have Skills"],
                "good_to_have":state["Good To Have Skills"],
                "join_condition":state.joinCondition
               },
        "onlyTop": state.onlyTop,
        "onlyNonExported": state.onlyNonExported,
        current_state: state?.currentState?.length! > 0 ? state?.currentState : [0],
        download_status: state?.downloadStatus,
        company,
        industry: state.preferredIndustries?.length ? {any_scope: state.cpc,industries:state.preferredIndustries,include_profiles_with_no_industries: state.ipi } : undefined,
        gender: state.gender,
        age: state.age,
        location: state.location,
        contact_info_avaibility: state.contactInfo,
        email_campaign: state.emailCampaign,
        shortlisted_by: state.shortlistedBy,
        functions: state.functions
      },
    },
    api_profile_flag: state.apiProfileFlag || 0,
    queries: state.queries,
  };

  return payload;
}

export function getSearchRedirectionPath(id: number) {
  const domain = extractDomain();
  return `${domain}/edge/recruiter/edit-saved-search-v1?searchId=${id}&cn=in`;
};

export function getFilterValuesFromForm(formValues: IFilterFormValues) {
  const {sort_by_profile_ranking_score,onlyTop,onlyNonExported, age, companies, contactedBy, contactInfo, downloadStatus, experience, functions, gender, industry, jobs, location, roles, responseType, salary, shortlistedBy, query, contactedWithin, shortlistedWithin, emailCampaign,currentState,cpc,ipi ,is_preferred_designations,designation_categories,designations,designations_scope} = formValues
  const values: IInitialFilterState = {}

  if (contactInfo.length) {
    const contactInfoValues: IContactInfoValues = {};

    let isVerifiedPhone = false;
    let isUnVerifiedPhone = false;
    let isVerifiedEmail = false;
    let isUnVerifiedEmail = false;
    let hasNoContact = false;

    contactInfo.map((c) => {
      isVerifiedPhone = c.name.includes("Verified phone") || isVerifiedPhone
      isUnVerifiedPhone = c.name.includes("Unverified phone") || isUnVerifiedPhone
      isVerifiedEmail = c.name.includes("Verified email") || isVerifiedEmail
      isUnVerifiedEmail = c.name.includes('Unverified email') || isUnVerifiedEmail
      hasNoContact = c.name.includes("No contact available") || hasNoContact

      return c
    })

    if (isUnVerifiedPhone) contactInfoValues.has_verified_phone = 0;
    if (isVerifiedPhone) contactInfoValues.has_verified_phone = 1;
    if (isUnVerifiedPhone && isVerifiedPhone) contactInfoValues.has_verified_phone = undefined;

    if (isUnVerifiedEmail) contactInfoValues.has_verified_email = 0;
    if (isVerifiedEmail) contactInfoValues.has_verified_email = 1;
    if (isUnVerifiedEmail && isVerifiedEmail) contactInfoValues.has_verified_email = undefined;

    if (hasNoContact) contactInfoValues.has_no_contact_info = 1;

    values.contactInfo = { ...contactInfoValues };
  }

  if (downloadStatus.length && downloadStatus !== "both") {
    let status = [0, 1]

    if (downloadStatus === 'downloaded') status = [1]
    if (downloadStatus === 'not_downloaded') status = [0]

    values.downloadStatus = status;
  }

  if (experience.years.min
    || experience.years.max
    || experience.months.max
    || experience.months.min) {
    values.experience = {
      min_exp: (experience.years.min || 0) + ((experience.months.min || 0) / 100),
      max_exp: (experience.years.max || 45) + ((experience.months.max || 0) / 100)
    }
  }

  if (age.min || age.max) values.age = { min_age: age.min || 0, max_age: age.max || 99 };
  if (companies.length) values.currentCompany = companies.map((c) => c.name);
  if (currentState.length) values.currentState = currentState;
  if (formValues["Good To Have Skills"].length) values["Good To Have Skills"] = formValues["Good To Have Skills"];
  if (formValues["Must Have Skills"].length) values["Must Have Skills"] = formValues["Must Have Skills"];
  if (formValues["Must Have Skills"].length || formValues["Good To Have Skills"].length) values.joinCondition = "OR";
  if (onlyTop) values.onlyTop = onlyTop;
  if (sort_by_profile_ranking_score) values.sort_by_profile_ranking_score=sort_by_profile_ranking_score==="recent"?false:true
  if (onlyNonExported) values.onlyNonExported = onlyNonExported;
  if (contactedBy.length) values.contactedBy = contactedBy.map((r) => r.value);
  if (industry.length)  values.preferredIndustries = industry.map((r) => r.name)
  if (industry.length) values.cpc = cpc;
  if (industry.length) values.ipi = ipi;

    values.is_preferred_designations=is_preferred_designations;

  values.designations_scope = designations_scope;
  if(designation_categories && designation_categories?.length >0){
    values.designations_categories =[...designation_categories]
  }
  if(designations && designations?.length >0){
    values.designations =[...designations]
  }
  if (responseType.length) values.responseType = responseType.map((r) => r.name);
  if (shortlistedBy.length) values.shortlistedBy = shortlistedBy.map((s) => s.id);
  if (gender.length && gender !== "any") values.gender = gender;
  if (query.length) values.queries = query;
  if (contactedWithin.startDate || contactedWithin.endDate) values.contactedWithin = { start_date: contactedWithin.startDate, end_date: contactedWithin.endDate };
  if (shortlistedWithin.startDate || shortlistedWithin.endDate) values.shortlistedWithin = { start_date: shortlistedWithin.startDate, end_date: shortlistedWithin.endDate };
  if (emailCampaign.length > 0) values.emailCampaign = emailCampaign.map((item) => item.id);
  if (salary.min && salary.max) values.salary = {
    min_ctc: parseFloat(salary.min.replace(/,/g, '')),
    max_ctc: parseFloat(salary.max.replace(/,/g, '')),
    currency_code: 'INR'
  }

  
  if (roles.length) {
    const funcRoles = functions.map((f) => {
      const children = f.children.map((f) => f.id)

      return {
        functions: [f.name],
        roles: roles.filter((r) => children.includes(r.id)).map((r) => r.name)
      }
    })

    values.functions = funcRoles
  }

  if (location.current.length) {
    values.location = {
      location_enabled: location.show,
      current_location: location.current.length
        ? location.current.map((c) => c.name)
        : undefined,
      curr_and_pref_loca_condition: location.show ? 'OR' : undefined,
      preferred_location: location.show
        ? location.current.map((p) => p.name)
        : undefined,
    };
  }


  return values;
}

interface DataItem {
  id: number;
  label: string;
  count?: number | null | undefined;
}


export function calculateSumOfProfileCount(data: DataItem[]): number {
  let sum = 0;
  for (const item of data) {
    if (item.hasOwnProperty('count')) {
      sum += item.count || 0;
    }
  }
  return sum;
}

export function capitalizeFirstLetters(inputString: string) {
  return inputString.replace(/\b\w/g, (match) => match.toUpperCase());
}

export function returnURL() {
  const userDetails = getUserDetails();
  if (userDetails) {
    if (userDetails.jp_type) {
      if (userDetails.jp_type === "JP") {
        return false;
      } else if (userDetails.jp_type === "EJP") {
        return true;
      }
    }
    
   else if (userDetails.product_type === "edge") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
